// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var MobileNumber = function MobileNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.68 10.75a1.56 1.56 0 0 0-1.825.445l-1.296 1.586a12 12 0 0 1-4.34-4.34L8.8 7.148c.539-.44.722-1.183.445-1.824L7.371.95A1.56 1.56 0 0 0 5.61.035L1.234.973A1.56 1.56 0 0 0 0 2.5c0 9.031 6.844 16.469 15.629 17.402q.573.061 1.156.086h.004q.355.014.711.016a1.56 1.56 0 0 0 1.527-1.234l.938-4.375a1.56 1.56 0 0 0-.914-1.762l-4.375-1.875zm2.566 7.375C8.82 17.988 2.012 11.18 1.88 2.754l3.875-.832 1.68 3.922L6.03 6.992a1.875 1.875 0 0 0-.433 2.39 13.8 13.8 0 0 0 5.023 5.024c.797.461 1.809.278 2.39-.433l1.15-1.403 3.921 1.68z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
